import React, { Component, Fragment } from "react";
import { isEmpty } from 'lodash';
import classNames from "classnames";
import PropTypes from 'prop-types';

import logo from "../../../../assets/images/branding/logo-blue.svg";
import TextInput from "../../../shared/components/forms/TextInput";
import { segmentEventTracker } from '../../../../utils/SegmentEventTracker'
import { TrackEventName } from '../../../shared/constants/SegmentEvents';

const PASSWORD_LENGTH_THRESHOLD = 8;

export class ResetPasswordScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: "",
      confirm_password: "",
      errors: {},
    }
  }

  // TODO: work on improving validation
  // These three methods can be simplified
  // by using a validation js library Yup.
  // https://github.com/jquense/yup
  samePasswordValidator = () => {
    const { password, confirm_password, errors } = this.state;

    if (password !== confirm_password) {
      this.setState({ errors: {...errors, confirm_password: "Passwords didn't match. Please try again."} });
    } else {
      const { confirm_password, ...rest } = errors;
      this.setState({ errors: rest });
    };
  }

  onChangePassword = (e) => {
    const { password, errors } = this.state;

    return this.setState({ password: e.target.value }, () => {
      if (password.length < PASSWORD_LENGTH_THRESHOLD) {
        this.setState({ errors: {...errors, password: 'Password should be more than 8 characters long.'} });
      } else {
	const { password, ...rest } = errors;
	this.setState({ errors: rest }, this.samePasswordValidator);
      };
    });
  }

  onChangeConfirmPassword = (e) => {
    return this.setState(
      { confirm_password: e.target.value },
      this.samePasswordValidator
    )
  }

  onSubmit = () => {
    const { resetPasswordToken, userResetPassword } = this.props;
    const { password, confirm_password } = this.state;

    segmentEventTracker.trackEvent(TrackEventName.RESET_PASSWORD_CLICKED)

    const payload = {
      reset_password_token: resetPasswordToken,
      password: password,
      password_confirmation: confirm_password,
    };

    // Send update request to api
    userResetPassword(payload);
  }

  renderForm() {
    const { password, confirm_password, errors } = this.state;
    const { isResettingPassword } = this.props;

    const buttonClasses = classNames(
      "ds-btn",
      "--medium",
      "--full",
      {"_loading": false},
    );

    const buttonDisabled = isResettingPassword || !isEmpty(errors) || !password || !confirm_password;

    return (
      <Fragment>
        <section className="cardSection">
          <label className="ds-input" htmlFor="password">
            <span>Your New Password</span>
            <TextInput
              dataTestId="password-input"
              type="password"
              name="password"
              value={password}
              error={errors.password}
              onChange={this.onChangePassword}
            />
          </label>
          <label className="ds-input" htmlFor="password_confirmation">
            <span>Confirm New Password</span>
            <TextInput
              dataTestId="confirm-password-input"
              type="password"
              name="password_confirmation"
              value={confirm_password}
              error={errors.confirm_password}
              onChange={this.onChangeConfirmPassword}
            />
          </label>
        </section>
        <button
          data-testid="submit-button"
          className={buttonClasses}
          disabled={buttonDisabled}
          onClick={this.onSubmit}
        >
          Add Password
        </button>
      </Fragment>
    )
  }

  render() {
    return (
      <div className="ds-container _addButtonPadding">
        <div className="grid --narrow">
          <div className="logo _atLogin">
            <img
              src={logo}
              alt="Logo"
            />
          </div>
          <div className="ds-card _solo">{this.renderForm()}</div>
        </div>
      </div>
    )
  }
}

ResetPasswordScreen.propTypes = {
  isResettingPassword: PropTypes.bool,
  userResetPassword: PropTypes.func,
  resetPasswordToken: PropTypes.string,
}

export default ResetPasswordScreen;



// WEBPACK FOOTER //
// ./src/features/user/components/resetPassword/ResetPasswordScreen.js